export default __webpack_public_path__ + "static/media/29.eef40f75.gif";